module.exports = __webpack_public_path__ + "img/whale.7d1b1329.png";